import { useState } from "react";
import { Box, BoxProps, Button, Grid, Stack, Typography } from "@mui/material";
import { DadosChequeItems } from "../..";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DialogEditDadosPagamento from "../DialogEditDadosPagamento";
import { TCheque } from "../../../../../../../../types/api/financeiro/detalhar-cheques";

export default function CardDadosPagamento({
  boxStyle,
  detalhe,
}: CardDadosPagamentoProps) {
  const [openEdit, setOpenEdit] = useState(false);

  return (
    <>
      <Box {...boxStyle}>
        <Typography variant="h6">Dados para pagamento</Typography>

        <Grid container rowGap={2}>
          <Grid size={{xs: 6, md: 3}}>
            <DadosChequeItems
              titulo="Loja"
              valor={
                detalhe.dadosPagamento.loja
                  ? `${detalhe.dadosPagamento.loja.id} - ${detalhe.dadosPagamento.loja.nome}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 6, md: 3}}>
            <DadosChequeItems
              titulo="Lote"
              valor={
                detalhe.dadosPagamento.lote
                  ? `${detalhe.dadosPagamento.lote}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Data de origem"
              valor={
                detalhe.dadosPagamento.data_origem
                  ? `${detalhe.dadosPagamento.data_origem}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Valor"
              valor={
                detalhe.dadosPagamento.valor
                  ? new Intl.NumberFormat("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    }).format(Number(detalhe.dadosPagamento.valor))
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Conta devedora"
              valor={
                detalhe.dadosPagamento.conta_devedora
                  ? `${detalhe.dadosPagamento.conta_devedora.codigo_contabil} - ${detalhe.dadosPagamento.conta_devedora.nome}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Contra partida"
              valor={
                detalhe.dadosPagamento.contra_partida
                  ? `${detalhe.dadosPagamento.contra_partida.codigo_contabil} - ${detalhe.dadosPagamento.contra_partida.nome}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Centro de custo fiscal"
              valor={
                detalhe.dadosPagamento.departamento_centro_custo
                  ? `${detalhe.dadosPagamento.departamento_centro_custo.id} - ${detalhe.dadosPagamento.departamento_centro_custo.nome}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Praça"
              valor={
                detalhe.dadosPagamento.praca
                  ? `${detalhe.dadosPagamento.praca}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Data vencimento"
              valor={
                detalhe.dadosPagamento.data_vencimento
                  ? `${detalhe.dadosPagamento.data_vencimento}`
                  : "-"
              }
            />
          </Grid>
        </Grid>

        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="contained"
            size="small"
            startIcon={<EditOutlinedIcon />}
            sx={{ fontSize: "0.75rem" }}
            onClick={() => setOpenEdit(true)}
            disabled={Boolean(detalhe.dadosPagamento.data_baixa)}
          >
            Editar
          </Button>
        </Stack>

        {openEdit && (
          <DialogEditDadosPagamento
            open={openEdit}
            handleClose={() => setOpenEdit(false)}
          />
        )}
      </Box>
    </>
  );
}

interface CardDadosPagamentoProps {
  boxStyle: BoxProps;
  detalhe: TCheque;
}
